<template>
    <div class="customer_list">
        <div class="customer_titie" v-if="isShowTitle">
            OUR CUSTOMERS
        </div>
        <div class="customer_content">
            <div class="customer_statistics" v-if="isShowStatistics">
                <div class="statistics_box">
                    * There have <span class="storng_text">{{ statistics.installedCount }}</span> Publisher are already
                    using
                    Contrimetric·Plugin...
                </div>
                <div class="statistics_box">
                    * There have <span class="storng_text">{{ statistics.noInstallCount }}</span> Journals have
                    completed
                    plugin code
                    production...
                </div>
            </div>

            <div class="customer_image_list" v-if="isShowImage">
                <div
                    id="list_item"
                    :class="['list_item', `item-${index}`, { 'has-logo-bg': item.backgroundColor }]"
                    :style="listItemCardStyle(item)"
                    v-for="(item, index) in data"
                    :key="index"
                >
                    <img :src="item.image" :class="item.class" @click="goToBlank(item.link)">
                    <span v-if="item.text != ''" class="list_item_text">{{ item.text }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getUseJournalCount } from '@/api/widget';

export default {
    props: {
        isShowTitle: {
            type: Boolean,
            default: true
        },
        isShowStatistics: {
            type: Boolean,
            default: true
        },
        isShowImage: {
            type: Boolean,
            default: true
        },
        isShowUAImage: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            statistics: {
                noInstallCount: 0,
                installedCount: 0
            }
        }
    },
    methods: {
        listItemCardStyle(item) {
            if (!item.backgroundColor) {
                return {}
            }
            return { backgroundColor: item.backgroundColor }
        },
        goToBlank(link) {
            window.open(link, '_blank')
        },
        async getUseJournalCountFun() {
            await getUseJournalCount().then(res => {
                console.log({ ...res.data });
                this.statistics = { ...res.data }
            })
        }
    },
    async mounted() {
        if (this.isShowStatistics) await this.getUseJournalCountFun()
    },
}
</script>

<style lang="scss">
@import "../../assets/css/minix.scss";

.customer_list {
    @include responsive-width(1200px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-bottom: 40px;

    .customer_titie {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 30px;
    }

    .customer_content {
        width: 100%;

        .customer_statistics {
            position: relative;
            margin-bottom: 20px;
            display: flex;
            justify-content: space-around;
            font-size: 16px;
            width: 100%;
            padding: 20px 100px;
            background-color: #f4e5e5;
            box-sizing: border-box;
            overflow: hidden;

            &::before,
            &::after {
                content: "";
                position: absolute;
                top: 0;
                width: 35px;
                height: 100%;
                background-color: white;
            }

            &::before {
                left: 0;
                transform: skew(336deg);
                transform-origin: top right;
            }

            &::after {
                right: -28px;
                transform: skew(340deg);
                transform-origin: top left;
            }


            .statistics_box {
                .storng_text {
                    color: #8e0000;
                    font-size: 30px;
                    font-family: fantasy;
                }
            }
        }

        .customer_image_list_dx {
            .list_item {
                margin: 10px !important;
            }
        }

        .customer_image_list {
            display: flex;
            flex-wrap: wrap;

            .list_item_dx {
                width: 340px;
                height: 150px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: scale-down;
                }
            }

            .list_item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin: 10px;
                transition: all 0.3s;
                width: 380px;
                height: 190px;
                background-color: white;
                border-radius: 16px;
                padding: 20px;
                box-sizing: border-box;
                text-align: center;
                color: #333333;
                overflow: hidden;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                border: 1px solid #fff;

                &:hover {
                    cursor: pointer;
                }

                &:not(.has-logo-bg):hover {
                    background-color: #E9FDFF;
                    border: 1px solid #189EAE;
                    filter: opacity(0.7);
                }

                &.has-logo-bg {
                    border-radius: 16px;
                    color: #f5f5f5;

                    .list_item_text {
                        color: #f5f5f5;
                    }

                    img {
                        padding: 12px 16px;
                        box-sizing: border-box;
                    }

                    &:hover {
                        border: 1px solid #189EAE;
                        filter: brightness(1.08);
                    }
                }

                img {
                    width: 100%;
                    height: 70%;
                    object-fit: scale-down;
                }

                .is_journal {
                    height: 90%;
                    padding-top: 10px;
                }

                .list_item_text {
                    display: block;
                    margin-top: 10px;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .customer_list {
        padding: 0;

        .customer_content {
            .customer_statistics {
                position: static;
                flex-direction: column;
                padding: 20px;

                &::before,
                &::after {
                    content: "";
                    display: none;
                }

                .statistics_box {
                    text-align: justify;

                    &:nth-child(1) {
                        margin-bottom: 20px;
                    }
                }
            }

            .customer_image_list {
                justify-content: center;

                #list_item {
                    margin: 10px;
                    width: 100%;
                    height: 190px;

                    img {
                        width: 100%;
                    }

                    .list_item_text {
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>